hoculus.hoculusScrollingText = class extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const observerOptions = {
            root: null,
            rootMargin: "0px",
        };

        function intersectionCallback(entries) {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    this.classList.remove("pause-animation");
                } else {
                    this.classList.add("pause-animation");
                }
            }
        }

        // V19: l'HTML contiene solo 2 copie; qui si ricreano le altre (aria-hidden) per lo scorrimento infinito
        const copie = parseInt(this.dataset.copies || "0", 10);
        const primo = this.querySelector(".scroll-element-container");
        if (primo && copie > 0) {
            const frammento = document.createDocumentFragment();
            for (let n = this.querySelectorAll(".scroll-element-container").length; n < copie; n++) {
                const copia = primo.cloneNode(true);
                copia.setAttribute("aria-hidden", "true");
                copia.querySelectorAll("a").forEach((a) => a.setAttribute("tabindex", "-1"));
                frammento.appendChild(copia);
            }
            this.appendChild(frammento);
        }

        const observer = new IntersectionObserver(intersectionCallback.bind(this), observerOptions);
        observer.observe(this);

        if (this.dataset.behavior === "slides") {
            const blocks = this.querySelectorAll(".scroll-element");
            const blocksContainer = blocks[0].parentNode;
            let i = 0;
            let j = 2;

            this.addEventListener('animationend', () => {
                this.style.animation = 'none';

                blocks[i].classList.add("d-none")
                blocks[j].classList.remove("d-none");
                blocksContainer.appendChild(blocks[i]);
                blocksContainer.appendChild(blocks[j]);
                i++;
                j++;

                if (!blocks[i]) i = 0;
                if (!blocks[j]) {
                    j = 0;
                };

                setTimeout(() => {
                    this.style.animation = '';
                });
            });
        }
    }
}


if(!customElements.get("hoculus-scrolling-text")) customElements.define("hoculus-scrolling-text", hoculus.hoculusScrollingText);

